import React, {useState,useEffect} from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import Cookies from 'js-cookie';
import PerfectScrollbar from "perfect-scrollbar";
import { Nav } from "reactstrap";
import {BackgroundColorContext} from "contexts/BackgroundColorContext";
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import axios from "axios";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import { Button } from "@mui/material";
import { ControlPoint } from "@mui/icons-material";

var ps;


function Sidebar(props) {
  const location = useLocation();
  const sidebarRef = React.useRef(null);
  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname === routeName ? "active" : "";
  };

  const [photo, setPhoto] = useState(null)
  const [name, setName] = useState(null)

  useEffect(() => {
    axios.get('https://back.actelmon.ir/api/doctor/profile/', {
      headers: {
        Authorization: `${Cookies.get('token')}` // Assuming you have a function to get the cookie value
      }
    })
      .then((response) => {
        setName(response.data.name + ' ' + response.data.last_name);
        setPhoto(response.data.photo);
        Cookies.set('doctorID',response.data.id);
        Cookies.set('doctorName',response.data.name + ' ' + response.data.last_name);
      })
      .catch((error) => {
        console.error('Error fetching sidebar data:', error);
      });

  }, []);

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(sidebarRef.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
    };
  });
  const linkOnClick = () => {
    document.documentElement.classList.remove("nav-open");
  };
  const { routes, rtlActive, logo } = props;
  let logoImg = null;
  let logoText = null;
  if (logo !== undefined) {
    if (logo.outterLink !== undefined) {
      logoImg = (
        <a
          href={logo.outterLink}
          className="simple-text logo-mini"
          target="_blank"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo"
            style={{height:'50px',width:'auto'}}/>
          </div>
        </a>
      );
      logoText = (
        <a
          href={logo.outterLink}
          className="simple-text logo-normal"
          target="_blank"
          onClick={props.toggleSidebar}
          style={{color:'#DD8E9C', fontSize:'1px',fontWeight:'bold'}}
        >
          .
        </a>
      );
    } else {
      logoImg = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-mini"
          onClick={props.toggleSidebar}
        >
          <div className="logo-img">
            <img src={logo.imgSrc} alt="react-logo"
                 style={{height:'50px',width:'auto'}}/>
          </div>
        </Link>
      );
      logoText = (
        <Link
          to={logo.innerLink}
          className="simple-text logo-normal"
          onClick={props.toggleSidebar}
          style={{color:'#DD8E9C', fontSize:'1px',fontWeight:'bold'}}
        >
          .
        </Link>
      );
    }
  }

  const [isHovered, setIsHovered] = useState(false);
  const handleMouseEnter = () => {setIsHovered(true);};
  const handleMouseLeave = () => {setIsHovered(false);};

  const hoverStyle = {
    backgroundColor: '#F6DDE2',
    //backgroundColor:  '#BAEEF3',
    color:  'black' ,
  };
  const selectStyle = {
    backgroundColor: '#BAEEF3',
    //backgroundColor:  '#BAEEF3',
    color:  'black' ,
  };
  const hoverStyleLO = {
    backgroundColor: isHovered ? '#F6DDE2' : 'transparent',
    //backgroundColor:  '#BAEEF3',
    color:  'black' ,
  };

  const handleLogout = () => {
    console.log('log out')
  };

  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <BackgroundColorContext.Consumer>
      {({ color }) => (
        <div className="sidebar" data={color} style={{
          backgroundColor:'white',
          margin:'0px',
          height:'inherit',
        }}>
          <div className="sidebar-wrapper" ref={sidebarRef} style={{backgroundColor:'white', textAlign: 'center' }}>
          <div className="d-flex flex-row-reverse justify-content-center align-items-center">
        <img src={require("../../assets/img/blueblack.png")} alt="react-logo"
                 style={{height:'58px',width:'auto', marginTop:'15px'}}/>
                <i className="tim-icons icon-simple-remove p-4 mt-2 font-weight-bold d-block d-lg-none" 
                onClick={props.toggleSidebar}></i>

          </div>
            

            <Avatar
              alt={name}
              src={photo}
              sx={{
                width: 120,
                height: 120,
                backgroundColor: 'primary.main',
                margin: '0 auto',
                marginBottom: 2,
                marginTop: 2,
              }}
            />
            <Typography variant="h6" component="div" sx={{ textAlign: 'center', color:'#DD8E9C', fontWeight:'bold' }}>
              {name}
            </Typography>

            <Nav>
              {routes.map((prop, key) => {
                if (prop.redirect) return null;

                if (prop.path === '/addpatient') return null;
                if (prop.path === '/newexercise') return null;
                if (prop.path === '/patientprofile') return null;
                if (prop.path === '/sessionreport') return null;
                if (prop.path === '/editexercise') return null;

                if (location.pathname === '/rtl/support') {
                  window.open("http://actelmon.ir/call-support/");
                  location.pathname = '/rtl/dashboard'
                }

                // Check if the current item is being hovered
                const isHovered = hoveredItem === key;

                // Check if the current item is the selected one
                const isSelected = location.pathname === ('/rtl'+prop.path);

                return (
                  <li
                    className={
                      activeRoute(prop.path) + (prop.pro ? " active-pro" : "")
                    }
                    key={key}
                    style={isHovered ? { ...hoverStyle } : isSelected ? { ...selectStyle } : null}
                    //style={isHovered ? hoverStyle : null}
                    onMouseEnter={() => setHoveredItem(key)}
                    onMouseLeave={() => setHoveredItem(null)}
                  >
                    <NavLink
                      // for charts
                      to={prop.path === "/chart" ? '#' : prop.layout + prop.path}
                      className="nav-link"
                      onClick={props.toggleSidebar}
                    >
                      <i className={prop.icon} style={{ color: isHovered || isSelected ? '#D0576E' : '#757575' }} />
                      <p style={{ color: isHovered || isSelected ? '#000000' : '#757575', fontSize: '15px' }}>
                        {rtlActive ? prop.rtlName : prop.name}
                      </p>
                    </NavLink>
                  </li>
                );
              })}
              <li
                onClick={handleLogout}
                style={hoverStyleLO}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                <NavLink className="nav-link" onClick={() => {
                  Cookies.set('token',null)
                  localStorage.removeItem('token');
                  window.location.href = '/login'
                }}>
                  <i className="tim-icons icon-minimal-right" style={{ color: isHovered ? '#D0576E' : '#757575' }}/>
                  <p style={{color: isHovered ? 'black' : '#757575', fontSize:'15px'}}>خروج</p>
                </NavLink>
              </li>
            </Nav>
          </div>
        </div>
      )}
    </BackgroundColorContext.Consumer>
  );
}

Sidebar.propTypes = {
  // if true, then instead of the routes[i].name, routes[i].rtlName will be rendered
  // insde the links of this component
  rtlActive: PropTypes.bool,
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the text of the logo
    text: PropTypes.node,
    // the image src of the logo
    imgSrc: PropTypes.string,
  }),
};

export default Sidebar;
